import { IconButton } from '@mui/material';
import CONFIG from '../../../config';
import React from 'react';
import WidgetCheckbox from '../../../components/widgets/WidgetCheckbox';
import DownloadIcon from '@mui/icons-material/Download';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WidgetInputText from '../../../components/widgets/WidgetInputText';
import DocumentState from '../../client/dossier/DocumentState';
import axios from "axios";
import WidgetFile from '../../../components/widgets/WidgetFile';
import WidgetDropZone from '../../../components/widgets/WidgetDropZone';


function FicheDocuments({ user, setUser, title, type_dossier, document_name, doc, uploadable = false }) {
  const [obligatoire, setObligatoire] = React.useState(null);
  const [message, setMessage] = React.useState(null);


  React.useEffect(() => {
    if (obligatoire !== null && obligatoire.value !== (doc.obligatoire_cond || doc.obligatoire_admin)) {
      let payload = { obligatoire: obligatoire.value };
      axios.post(CONFIG.API_URL + '/api/set_document_obligatoire/' + user._id + '/' + type_dossier + '/' + document_name, payload, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
        .then((response) => {
          switch (response.status) {
            case 200:
              setUser(response.data);
              break;

            default:
              break;
          }
        })
        .catch((e) => {
          let response = e.response;

          console.log(response);

          if (response === undefined) {
            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
            return;
          }

          switch (response.status) {
            default:
              alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
              break;
          }
        });
    }
  }, [obligatoire]);


  return (
    <>
      <div className='flex col-span-12 w-full text-center justify-between py-4'>
        <div className='flex text-center items-center'>
          <div className='pr-4 w-64 text-start'>
            <h3>{title}</h3>
          </div>

          <div className='pr-4 w-32 text-start'>
            <DocumentState etat={doc.etat}></DocumentState>
          </div>
        </div>

        <div className='flex text-center items-center'>
          <div className='pr-4 text-sm'>
            <IconButton onClick={() => {
              axios.get(CONFIG.API_URL + '/api/client_download_document/' + user._id + '/' + type_dossier + '/' + document_name, { responseType: 'blob', headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token'), 'Cache-Control': 'no-cache' } })
                .then((response) => {
                  switch (response.status) {
                    case 200:
                      // create file link in browser's memory
                      const href = URL.createObjectURL(response.data);

                      // create "a" HTML element with href to file & click
                      const link = document.createElement('a');
                      link.href = href;
                      link.setAttribute('download', title + ' - ' + user.nom + ' ' + user.prenom); //or any other extension
                      document.body.appendChild(link);
                      link.click();

                      // clean up "a" element & remove ObjectURL
                      document.body.removeChild(link);
                      URL.revokeObjectURL(href);
                      break;

                    default:
                      break;
                  }
                })
                .catch((e) => {
                  let response = e.response;

                  if (response === undefined) {
                    alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                    return;
                  }

                  switch (response.status) {
                    default:
                      alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                      break;
                  }
                });
            }}><DownloadIcon></DownloadIcon></IconButton> {Object.keys(doc.fichiers).length} Fichier(s)
          </div>

          <div className='pr-2 w-96'>
            <WidgetInputText state={message} setState={setMessage} id={'message'} text={"Commentaire"} size="small" value={doc.message} />
          </div>

          <div className=''>
            <IconButton onClick={() => {
              let payload = { 'message': message.value, 'rejet': true };
              axios.post(CONFIG.API_URL + '/api/retour_document/' + user._id + '/' + type_dossier + '/' + document_name, payload, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                .then((response) => {
                  switch (response.status) {
                    case 200:
                      setUser(response.data);
                      break;

                    default:
                      break;
                  }
                })
                .catch((e) => {
                  let response = e.response;

                  if (response === undefined) {
                    alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                    return;
                  }

                  switch (response.status) {
                    default:
                      alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                      break;
                  }
                });
            }}><CancelIcon className='text-red-500'></CancelIcon></IconButton>
          </div>

          <div className='pr-4'>
            <IconButton onClick={() => {
              let payload = { 'message': message.value, 'rejet': false };
              axios.post(CONFIG.API_URL + '/api/retour_document/' + user._id + '/' + type_dossier + '/' + document_name, payload, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                .then((response) => {
                  switch (response.status) {
                    case 200:
                      setUser(response.data);
                      break;

                    default:
                      break;
                  }
                })
                .catch((e) => {
                  let response = e.response;

                  if (response === undefined) {
                    alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                    return;
                  }

                  switch (response.status) {
                    default:
                      alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                      break;
                  }
                });
            }}><CheckCircleIcon className='text-green-500'></CheckCircleIcon></IconButton>
          </div>
        </div>

        <div className='flex text-center items-center'>
          {!uploadable ? (
            <div className=''>
              <WidgetCheckbox state={obligatoire} setState={setObligatoire} id={'obligatoire'} text={"Obligatoire"} value={doc.obligatoire_cond || doc.obligatoire_admin} disabled={doc.obligatoire_cond} />
            </div>
          ) : (
            <div className="w-96 grid grid-cols-12 gap-1">
              <div className="col-span-6 grid grid-cols-12 h-min">
                {Object.keys(doc.fichiers).map(key => {
                  const file = doc.fichiers[key];
                  return (<WidgetFile key={key} id_client={user._id} type_dossier={type_dossier} document_name={document_name} index={key} path={file.path} name={file.nom} setUser={setUser} ></WidgetFile>)
                })}
              </div>
              <div className="col-span-6">
                <WidgetDropZone type_dossier={type_dossier} document_name={document_name} user={user} setUser={setUser}></WidgetDropZone>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default FicheDocuments;